// 获取表盘信息的返回数据中大部分是对应着具体模块的
// 这些是不对应具体模块的
const FILTER_KEYS = ['metas', 'assets', 'order', 'idleConfig', 'hide']

export default FILTER_KEYS
